import React from 'react';
import { Link } from 'react-router-dom';
import SectorPage from '../components/SectorPage';
import Ticker from '../components/Ticker';

// ─── Tokens ────────────────────────────────────────────────────────────────────
const SERIF = "'Newsreader', Georgia, serif";
const NAVY  = '#16304a';
const BEIGE = '#f6efe2';
const SELF  = '/coverage/healthcare';

// ─── Sponsored Band (untouched) ────────────────────────────────────────────────
function SponsoredBand() {
  return (
    <div style={{ background: BEIGE, marginTop: 36 }} data-testid="hc-sponsored-band">
      <div className="container-custom">
        <div style={{ padding: '24px 0' }}>
          <div style={{ fontWeight: 700, fontSize: 9.5, letterSpacing: '1.4px', textTransform: 'uppercase', color: '#a8967a', marginBottom: 10 }}>Sponsored</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 30, flexWrap: 'wrap' }}>
            <div style={{ flex: '1 1 0', minWidth: 280 }}>
              <h2 style={{ fontFamily: SERIF, fontWeight: 500, fontSize: 25, lineHeight: 1.1, margin: '0 0 7px', color: NAVY }}>Stronger benefits. Healthier teams. Better outcomes.</h2>
              <p style={{ fontSize: 13, color: '#6c6258', margin: '0 0 9px', maxWidth: 420 }}>Flexible health plans and expert support for today's workforce.</p>
              <Link to={SELF} style={{ color: NAVY, fontWeight: 600, fontSize: 12.5, textDecoration: 'none' }}>Learn More&nbsp;→</Link>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexShrink: 0 }}>
              <svg width="56" height="44" viewBox="0 0 64 48" fill="none" strokeLinecap="round" aria-hidden="true">
                <path d="M4 38h56" stroke="#c79a3a" strokeWidth="1.6"/>
                <path d="M4 38c14-22 42-22 56 0" stroke="#1d6f6a" strokeWidth="2"/>
                <line x1="20" y1="14" x2="20" y2="38" stroke="#16304a" strokeWidth="1.6"/>
                <line x1="44" y1="14" x2="44" y2="38" stroke="#16304a" strokeWidth="1.6"/>
                <line x1="12" y1="30" x2="12" y2="38" stroke="#16304a" strokeWidth="1.6"/>
                <line x1="32" y1="22" x2="32" y2="38" stroke="#16304a" strokeWidth="1.6"/>
                <line x1="52" y1="30" x2="52" y2="38" stroke="#16304a" strokeWidth="1.6"/>
              </svg>
              <div>
                <div style={{ fontFamily: SERIF, fontSize: 25, lineHeight: 1, color: NAVY, fontWeight: 500 }}>HealthBridge</div>
                <div style={{ fontSize: 9, letterSpacing: '2px', textTransform: 'uppercase', color: '#8a8170', marginTop: 4 }}>Insurance Solutions</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Sector Config ─────────────────────────────────────────────────────────────
const HEALTHCARE_CONFIG = {
  slug: 'healthcare',
  label: 'Healthcare',
  selfPath: SELF,
  heroSlug: 'coverage/healthcare',
  h1Text: 'Healthcare',
  h1Subtitle: 'Leadership, hospitals, policy, workforce — and the solutions shaping a healthier future.',
  h1Body: 'Independent reporting and smart analysis on the people, policies, and innovations driving better health and stronger communities.',
  briefingCtaText: "Read Today's Healthcare Briefing",
  storiesCtaText: 'Explore Healthcare Briefings',
  storiesAnchorId: 'sp-stories',
  gridLabel: 'Healthcare Briefings',
  testId: 'healthcare-page',
  rightRailWidgets: [
    { type: 'video_of_week', duration: '6:15', title: 'Inside the Rural Hospital Comeback', description: 'How communities are rebuilding local care with innovation and partnership.' },
    { type: 'in_focus', label: 'Hospital in Focus', name: 'MaineGeneral Health', description: 'Expanding access, strengthening care, and investing in the future of healthcare.' },
    { type: 'executive_spotlight', initials: 'JB', name: 'Jamie Brown', title: 'CEO, Community Health Solutions', description: 'Driving equitable care through innovation and collaboration.' },
    { type: 'cta_pair' },
    { type: 'leaving_soon' },
    { type: 'first_round_promo' },
  ],
};

// ─── Page ──────────────────────────────────────────────────────────────────────
export default function HealthcarePage() {
  return (
    <SectorPage
      config={HEALTHCARE_CONFIG}
      PulseBar={() => <Ticker scope="healthcare" />}
      SponsoredBand={SponsoredBand}
    />
  );
}
